'use strict';

module.exports = [function () {
    return {
        replace: true,
        template: require('./tableInputFind.html')
    };
}];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/directives/layout/tableInputFind.js
// module id = 370
// module chunks = 0